import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/system';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import StyledInputLabelColorAndItemDescriptionsFont from 'components/StyledInputLabelColorAndItemDescriptionsFont';
import StyledSelectOptionColors from 'components/StyledSelectOptionColors';

const StyledInputLabel = styled(StyledInputLabelColorAndItemDescriptionsFont)(
  ({ theme }) => {
    return {
      marginTop: '5px',
      transform: 'translate(12px, 12px) scale(0.75) !important',
      '&.Mui-focused:not(&.Mui-error)': {
        color: theme.palette.secondary.main
      }
    };
  }
);

const StyledFormControl = styled(FormControl)(({ theme, fullWidth }) => ({
  width: '100%',
  marginBottom: fullWidth ? '20px' : 0,
  [theme.breakpoints.up('sm')]: {
    width: fullWidth ? '100%' : '168px'
  }
}));

const StyledSelect = styled(StyledSelectOptionColors)(({ theme }) => ({
  marginTop: '5px',
  '& .MuiNativeSelect-select': {
    marginTop: '7px',
    '&:focus': {
      boxShadow: 'inset 0 -3px ' + theme.palette.secondary.main,
      transition: 'box-shadow 100ms'
    }
  }
}));

function Select({
  label,
  value,
  onChange,
  options,
  id,
  disabled,
  fullWidth,
  dataTestId
}) {
  return (
    <StyledFormControl fullWidth={fullWidth}>
      <StyledInputLabel htmlFor={id}>{label}</StyledInputLabel>
      <StyledSelect
        native
        id={id}
        data-testid={dataTestId}
        value={value}
        onChange={onChange}
        disabled={disabled}
        variant="outlined"
        input={<OutlinedInput />}
      >
        {options.map((option, index) => (
          <option disabled={option.disabled} key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </StyledSelect>
    </StyledFormControl>
  );
}

Select.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  options: PropTypes.array,
  id: PropTypes.string,
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  dataTestId: PropTypes.string
};

export default Select;
